export default __webpack_public_path__ + "static/media/Image From ET__UI1.691cad9d.png";